module.exports = __webpack_public_path__ + "img/840.db89fc3e.svg";